export default "__VITE_ASSET__DnFKar95__"